export default __webpack_public_path__ + "static/media/IMG_3234.02acc60b.jpeg";